module.exports = __webpack_public_path__ + "static/media/Prayer.2803461d.png";